/* eslint-disable */
// @ts-ignore
import {Handler, Chunker, Polisher} from "pagedjs";

// noinspection JSUnusedGlobalSymbols
class PagedJsReportHandler extends Handler {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(chunker: Chunker, polisher: Polisher, caller: any) {
        super(chunker, polisher, caller);
    }

    // Previewer events
    beforePreview(content: any, renderTo: any) {
        this.log("beforePreview");
    }
    afterPreview(pages: any) {
        this.log("afterPreview");
    }

    // Chunker events
    beforeParsed(content: any) {
        this.log("beforeParsed");
    }

    afterParsed(parsed: any) {
        this.log("afterParsed");
    }

    beforePageLayout(page: any) {
        this.log("beforePageLayout");
    }

    afterPageLayout(pageElement: any, page: any, breakToken: any) {
        this.log("afterPageLayout");
    }

    afterRendered(pages: any) {
        this.log("afterRendered");
    }

    // Polisher events
    beforeTreeParse(text: any, sheet: any) {
        this.log("beforeTreeParse");
    }

    beforeTreeWalk(ast: any) {
        this.log("beforeTreeWalk");
    }

    afterTreeWalk(ast: any, sheet: any) {
        this.log("afterTreeWalk");
    }

    onUrl(urlNode: any) {
        this.log("onUrl");
    }

    onAtPage(atPageNode: any) {
        this.log("onAtPage");
    }

    onRule(ruleNode: any) {
        this.log("onRule");
    }

    onDeclaration(declarationNode: any, ruleNode: any) {
        this.log("onDeclaration");
    }

    onContent(contentNode: any, declarationNode: any, ruleNode: any, sheet: any) {
        this.log("onContent");
    }

    // Layout events
    layoutNode(node: any) {
        //console.log(`layoutNode`);
    }

    renderNode(node: any, sourceNode: any) {
        //console.log(`renderNode`);
    }

    onOverflow(overflow: any, rendered: any, bounds: any) {
        //console.log("onOverflow");
    }

    onBreakToken(breakToken: any, overflow: any, rendered: any) {
        this.log("onBreakToken");
    }

    private log(message: string) {
        // console.log(message);
    }
}

export default PagedJsReportHandler